export default class LiveInputBroadcaster {
  constructor(targetSelector) {
    this.targetSelector = targetSelector
    this.targetElement = document.querySelector(
      `[data-name="${targetSelector}"]`
    )
    this.timeoutToClear = undefined

    this.onBlur = this.onBlur.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)

    this.targetElement.addEventListener('mouseover', this.onMouseOver)
    this.targetElement.addEventListener('focus', this.onFocus)
    this.targetElement.addEventListener('blur', this.onBlur)
  }

  onBlur() {
    window.eventHub.$emit(`aiProposedInput:blur:${this.targetSelector}`)
  }
  onFocus() {
    window.eventHub.$emit(`aiProposedInput:focus:${this.targetSelector}`)
  }
  onMouseOver(event) {
    window.clearTimeout(this.timeoutToClear)

    this.timeoutToClear = window.setTimeout(() => {
      window.eventHub.$emit(`aiProposedInput:mouseover:${this.targetSelector}`)
    }, 500)

    event.target.addEventListener('mouseout', this.onMouseOut)
  }
  onMouseOut(event) {
    window.clearTimeout(this.timeoutToClear)

    window.eventHub.$emit(`aiProposedInput:mouseout:${this.targetSelector}`)
    event.target.removeEventListener('mouseout', this.onMouseOut)
  }

  teardown() {
    this.targetElement.removeEventListener('mouseover', this.onMouseOver)
    this.targetElement.removeEventListener('mouseout', this.onMouseOut)
    this.targetElement.removeEventListener('focus', this.onFocus)
    this.targetElement.removeEventListener('blur', this.onBlur)
  }
}
